import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export enum ButtonType { OK = 1, CONFIRMATION = 2 }

@Component({
    templateUrl: './warning-modal.html',
    standalone: false
})
export class WarningModalComponent {
  
  message: string;
  buttonType: number = ButtonType.CONFIRMATION;
  dangerBackground: boolean;

  constructor(public dialogRef: MatDialogRef<WarningModalComponent>, @Inject(MAT_DIALOG_DATA) data: any) {
    this.message = data.message;
    this.dangerBackground = data.dangerBackground;
    if (data.buttonType) {
      this.buttonType = data.buttonType;
    }
  }
}
